var map = {
	"./dope.jpg": 836,
	"./drakkar.jpg": 72,
	"./estaclaro.jpg": 880,
	"./hashiban.jpeg": 231,
	"./veintiuno.jpg": 833,
	"./verdadesymentiras.jpg": 666,
	"./yourgoal.jpg": 994
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 121;